module.exports = __webpack_public_path__ + "img/product-banner2.8e3ba646.png";